<template>
  <section
    class="sidearm-mm-results text-white relative bg-size-cover bg-position-center relative overflow-hidden h-100 "
    data-anchor="gameday"
  >
    <section-background css_var="--section-desktop-bg-selection-sunday-results"></section-background>
    <video-background
      v-if="section.background_type === 'video'"
      :video="section.background_video"
    />

    <div class="sidearm-mm-results-seed slide fp-noscroll">
      <div class="flex flex-align-center h-100">
        <div class="sidearm-mm-results__details col-3-of-8 col-push-1">
          <h2 class="type-heading-bracket-plain --light mt-0 mb-2">
            {{ section.title }}
          </h2>

          <h3 v-if="$root.data.team && $root.data.team.seed" class="type-hero mt-0 mb-4">
            Results: #{{ $root.data.team.seed }} Seed
          </h3>

          <p v-if="section.sub_title" class="type-paragraph-large">
            {{ section.sub_title }}
          </p>

          <div class="flex flex-align-center">
            <div></div>

            <matchup-bracket-desktop
              v-if="$root.upcoming_game"
              :round="$root.upcoming_game"
            >
              <button @click="moveSlideRight" class="sidearm-mm-btn --ghost">
                Gameday Experience
              </button>
            </matchup-bracket-desktop>
          </div>
        </div>

        <div class="sidearm-mm-results__divider col-1-of-8 relative">
          <span></span>
        </div>
      </div>
    </div>

    <div
      v-if="$root.upcoming_game"
      class="sidearm-mm-results-upcoming slide fp-noscroll"
    >
      <section-gameday-preview :round="$root.upcoming_game" />
    </div>

    <div v-if="$root.upcoming_game" class="slide fp-noscroll">
      <matchup-overview-desktop :round="$root.upcoming_game" />
    </div>
  </section>
</template>

<script>
import MatchupBracketDesktop from "@/components/MatchupBracketDesktop";
import MatchupOverviewDesktop from "@/components/MatchupOverviewDesktop";
import SectionGamedayPreview from "@/components/Sections/SectionGamedayPreview";

export default {
  components: {
    MatchupBracketDesktop,
    MatchupOverviewDesktop,
    SectionGamedayPreview
  },

  data: () => ({}),

  computed: {
    section() {
      if (!this.$root.data) {
        return null;
      }

      return this.$root.data.selection_sunday_section;
    }
  }
};
</script>

<style lang="scss" scoped>
.sidearm-mm-results {

  &__divider {
    > span {
      border-radius: 50%;
      border: 1px solid $color-white;
      display: block;
      height: 1.5rem;
      width: 1.5rem;
    }

    &::before {
      border-bottom: 1px solid $color-white;
      border-right: 1px solid $color-white;
      bottom: 50%;
      content: "";
      display: block;
      height: 100vh;
      left: 1.5rem;
      position: absolute;
      width: calc(100% - 1.5rem);
    }
  }
}
</style>
